'use client';

import { DatePicker, Typography } from 'lighthouse';

import { isAttributeRangeValid } from '@/utilities/attributeFilters';
import { ATTRIBUTE_FILTER_COPY } from '@/utilities/attributeFilters/constants';
import { jalaliToGregorian } from '@/utilities/jalaliToGregorian/jalaliToGregorian';

import { AttributeRangeFilterProps } from '../../models';

import { format } from 'date-fns-jalali';

const gregorianToJalaliDisplay = (value?: string) => {
    if (!value) {
        return '';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return format(date, 'yyyy-MM-dd');
};

export const AttributeRangeFilter = ({ attribute, selection, draft, onSetRange }: AttributeRangeFilterProps) => {
    const range = selection.ranges[attribute.slug];
    const isValid = isAttributeRangeValid(range);
    const draftOptions = draft ? { draft: true as const } : undefined;

    return (
        <div className='space-y-3'>
            <div className='grid grid-cols-1 gap-3'>
                <DatePicker
                    id={`${attribute.slug}-after`}
                    label={ATTRIBUTE_FILTER_COPY.fromDate}
                    value={gregorianToJalaliDisplay(range?.after)}
                    selectDate={(date) => onSetRange(attribute.slug, 'after', date ? jalaliToGregorian(date) : undefined, draftOptions)}
                    error={!isValid}
                    textFieldSize='small'
                />
                <DatePicker
                    id={`${attribute.slug}-before`}
                    label={ATTRIBUTE_FILTER_COPY.toDate}
                    value={gregorianToJalaliDisplay(range?.before)}
                    selectDate={(date) => onSetRange(attribute.slug, 'before', date ? jalaliToGregorian(date) : undefined, draftOptions)}
                    error={!isValid}
                    textFieldSize='small'
                />
            </div>
            {!isValid && (
                <Typography variant='caption' color='error' component='p'>
                    {ATTRIBUTE_FILTER_COPY.invalidRange}
                </Typography>
            )}
        </div>
    );
};
